import React, { Component } from "react";
import { connect } from "react-redux";
import { Collapse } from "antd";

import SubjectItem from "components/atar/SubjectItem";
import { ACTION_TYPE } from "reducers/actionType";
import { MOST_RELEVANT_SUBJECTS } from "utils/helpers";
import TableTopPopOver from "./pop-overs/TableTopPopOver";

import "styles/Cluster.scss";
const Panel = Collapse.Panel;

// keep state between mount and umount
let state = {
  openedPanels: []
};

class MostRelevantSubjects extends Component {
  constructor(props) {
    super(props);
    this.state = state;
  }

  componentWillUnmount() {
    // Remember state for the next mount
    state = this.state;
  }

  handleOpenPanel = openedPanels => {
    this.setState({ openedPanels });
  };

  handleToggleSubject = idNum => {
    const newSub = idNum.toString();
    const { userRecSubs } = this.props;
    const newUserRecSubs = Array.from(userRecSubs);
    if (newUserRecSubs.includes(newSub)) {
      newUserRecSubs.splice(newUserRecSubs.indexOf(newSub), 1);
    } else {
      newUserRecSubs.push(newSub);
    }
    this.props.dispatch({
      type: ACTION_TYPE.pickRecSubs,
      data: { userRecSubs: newUserRecSubs }
    });
  };

  countClusterUnits = (acc, o) => {
    if (o.type === "G") {
      const { group } = o;
      return group.reduce(this.countClusterUnits, acc);
    } else {
      const { subject } = o;
      const { userRecSubs } = this.props;
      if (userRecSubs.includes(subject.subject_num.toString())) {
        return acc + subject.units;
      } else {
        return acc;
      }
    }
  };
  renderSubjectItems = o => {
    const { userRecSubs } = this.props;
    if (o.type === "G") {
      const { group } = o;
      return (
        <Collapse
          bordered={false}
          className="cluster-container"
          key={o.identifier}
          onChange={this.handleOpenPanel}
          activeKey={this.state.openedPanels}
        >
          <Panel
            header={
              <div className="flex-space-between" style={{ width: "100%" }}>
                <h1 className="title">{o.identifier}</h1>

                {this.countClusterUnits(0, o) !== 0 && (
                  <div className="tag-cluster-count">
                    {this.countClusterUnits(0, o)}
                  </div>
                )}
              </div>
            }
            key={o.identifier}
            className="cluster-panel"
          >
            {group.map(sub => this.renderSubjectItems(sub))}
          </Panel>
        </Collapse>
      );
    } else {
      const { subject } = o;

      return (
        <SubjectItem
          key={subject.subject_num}
          {...subject}
          handleToggleSubject={() =>
            this.handleToggleSubject(subject.subject_num)
          }
          subjectItemSelected={userRecSubs.includes(
            subject.subject_num.toString()
          )}
          showSelect={true}
          subjectError={this.props.subjectErrorOb[subject.subject_num]}
        />
      );
    }
  };

  render() {
    const { recommendations } = this.props;

    return (
      <div className="most-relevant-subjects">
        <h1 className="title padding-sides">
          Select your preferred subjects: you need at least 12 units
        </h1>
        <TableTopPopOver />
        {recommendations
          .slice(0, MOST_RELEVANT_SUBJECTS)
          .map(rec => this.renderSubjectItems(rec))}
      </div>
    );
  }
}
const mapStateToProps = store => {
  const { input } = store.inputReducer;
  const { userRecSubs } = store.pickRecSubReducer;
  const { recommendations } = store.recommendationsReducer;
  return { input, userRecSubs, recommendations };
};

export default connect(mapStateToProps)(MostRelevantSubjects);
